import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-transfusi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-transfusi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/monitoring-transfusi", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-transfusi/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-transfusi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// TTV
async function addTtv(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-transfusi/${monitoringId}/ttv`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateTtv(monitoringId: number, ttvId: number, data: any) {
  const response = await http
    .putData(`/monitoring-transfusi/${monitoringId}/ttv/${ttvId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteTtv(monitoringId: number, ttvId: number) {
  const response = await http
    .deleteData(`/monitoring-transfusi/${monitoringId}/ttv/${ttvId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Reaksi
async function addReaksi(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-transfusi/${monitoringId}/reaksi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateReaksi(monitoringId: number, reaksiId: number, data: any) {
  const response = await http
    .putData(`/monitoring-transfusi/${monitoringId}/reaksi/${reaksiId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteReaksi(monitoringId: number, reaksiId: number) {
  const response = await http
    .deleteData(`/monitoring-transfusi/${monitoringId}/reaksi/${reaksiId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Workflow
async function mulaiTransfusi(id: number, data: any = {}) {
  const response = await http
    .postData(`/monitoring-transfusi/${id}/mulai`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function selesaiTransfusi(id: number, data: any = {}) {
  const response = await http
    .postData(`/monitoring-transfusi/${id}/selesai`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function finalisasi(id: number, data: any) {
  const response = await http
    .postData(`/monitoring-transfusi/${id}/finalisasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Signing
async function sign(id: number, data: { role: string; password: string }) {
  const response = await http
    .postData(`/monitoring-transfusi/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}


export interface LaporanReaksiPayload {
  tanggal_crosstest: string | null;
  tanggal_darah_keluar: string | null;
  petugas_bdrs: string | null;
  petugas_pengambil_darah: string | null;
  dokter_dikonsulkan_user_id: number | null;
  tindakan_setelah_konsul: string | null;
}

async function updateLaporanReaksi(id: number, data: LaporanReaksiPayload) {
  const response = await http
    .putData(`/monitoring-transfusi/${id}/laporan-reaksi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function openLaporanReaksiPdf(id: number): Promise<void> {
  const res = await http
    .getDataParam(`/monitoring-transfusi/${id}/laporan-reaksi/pdf`, {
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/monitoring-transfusi/${id}/pdf`,
    "_blank"
  );
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  addTtv,
  updateTtv,
  deleteTtv,
  addReaksi,
  updateReaksi,
  deleteReaksi,
  mulaiTransfusi,
  selesaiTransfusi,
  finalisasi,
  sign,
  updateLaporanReaksi,
  openLaporanReaksiPdf,
  printPdf,
};
